// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"2121bbe6","647":"5c1eae07"}[chunkId] + ".chunk.js";
};